import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const ServiceAssociateIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 255 255" {...rest} __css={styles}>
      <desc id="svgdescRelations">Associate with Headset</desc>
      <path
        className="background"
        d="M127.5 0C57.2 0 0 57.2 0 127.5S57.2 255 127.5 255 255 197.8 255 127.5 197.8 0 127.5 0z"
      />
      <path
        className="accent"
        d="M110.2 204.2c-10.8-.8-21.6-1.9-32.3-3.8-4.4-.8-8.8-1.6-13.1-2.7-5.7-1.5-7.5-4.3-6.7-10 2.5-17 11.9-29 26.7-37.1 6.9-3.8 14-7.1 21.1-10.5 2.5-1.2 3.5-2.1 1.3-4.8-2.5-3.1-4.5-6.6-5.6-11.9 5.4 3.8 10.9 4.8 15.8 7.5 5.1 2.9 10.7 1.6 16 .9 1.7-.2 2-2.2 1.8-3.9-.3-1.8-1.4-2.9-3.1-3-4.2-.1-8.4-.4-12.5.2-2.6.4-4.8.2-7.2-.7-3-1.1-5.7-2.6-8.3-4.4-3.8-2.6-6.5-5.8-7-10.7-1-8.6-1.9-17.2-.7-25.8 2.1-15 12-24 27.2-25.1 4.2-.3 8.4-.2 12.5.7C149 61.7 157 69.8 158.6 83c2.1 17.4 0 34.3-8.9 49.8-3.4 5.8-3.5 5.8 2.7 8.9 6 3 12.1 5.7 17.9 9 14.6 8 24.1 19.9 26.7 36.7 1 6.3-1.1 9.1-7.4 10.6-7.6 1.9-15.4 3-23.2 4-7.1.9-14.3 1.5-21.5 2.2h-34.7z"
      />
      <path
        className="accent"
        d="M135.4 43.7c3.4.9 6.9 1.4 10.3 2.5 15.6 5.3 24.7 15.8 25.9 32.5.2 2.7 1.1 4.3 3.3 5.7 3.4 2.2 5 5.6 4.9 9.7-.1 4.2 0 8.4 0 12.6-.1 6.9-5.9 12.3-12.8 12.3-2.8 0-2.7-1.8-2.7-3.7 0-9.8-.4-19.7.1-29.5 1-23.3-12.6-32.6-32-34.7-8.2-.9-16.2.3-23.9 3.5C96.7 59.5 91 68.5 90.8 81c-.2 11.3-.2 22.5 0 33.8.1 3.7-1.4 4.5-4.7 3.9-6.8-1.3-10.8-5.8-10.8-12.8 0-3.8.1-7.6 0-11.4-.2-4.7 1.7-8.1 5.5-10.6 1.5-1 2.5-2 2.6-4 1-22.6 16.9-32.9 34.4-35.7.6-.1 1.3-.3 1.9-.5h15.7z"
      />
    </Icon>
  );
};

export default ServiceAssociateIcon;
